/**
 * Do not edit directly
 */

export default "PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cmVjdCB4PSIwLjI1IiB5PSIwLjI1IiB3aWR0aD0iMjMuNSIgaGVpZ2h0PSIyMy41IiByeD0iMy43NSIgc3Ryb2tlPSIjQzdDRUQ0IiBzdHJva2Utd2lkdGg9IjAuNSIvPjxyZWN0IHg9IjUuNSIgeT0iNS41IiB3aWR0aD0iMTMiIGhlaWdodD0iMTMiIHN0cm9rZT0iYmxhY2siLz48L3N2Zz4=";